import React from "react";
import "./ServiceSB.css";
import Topbar from "../../components/Topbar/Topbar";
import Footer from "../../components/Footer/Footer";
import Strategy from "../../components/Strategy/Strategy";

const ServiceSB = () => {
    return (
        <>
            <Topbar />
            <div className="serviceSB-container">
                <Strategy />
                <Footer />
            </div>
        </>
    )
}

export default ServiceSB;